import React from 'react';
import Header from '../../Universal/Header';
import Footer from '../../Universal/Footer';
import './Policies.css';

const TermsAndConditions = () => {
    return (
        <div className="policy-page-header policy-page-wrapper">
            <Header />

            <div className="policy-hero">
                <div className="policy-hero-content">
                    <h1 className="policy-title">Terms & Conditions</h1>
                    
                </div>
            </div>

            <section className="policy-container">
                <div className="policy-content-wrapper">
                    <div className="policy-main-text">
                        <h3>General Terms</h3>
                        <p>Welcome to the B.E. College Ex-Students’ Club website. By accessing this website and making any payment, you agree to be bound by the following terms and conditions.</p>
                        <ol>
                            <li>The B.E. College Ex-Students’ Club is an alumni association formed for the benefit and engagement of ex-students of Bengal Engineering College (now IIEST, Shibpur).</li>
                            <li>Payments made on this website are towards membership fees, event participation fees, donations, or other club-related activities.</li>
                            <li>All information provided by users must be accurate and complete.</li>
                            <li>The Club reserves the right to modify, suspend, or discontinue any service or event without prior notice.</li>
                            <li>The Club is not responsible for any technical issues during online payments that are beyond its control.</li>
                            <li>By using this website, you agree to comply with all applicable laws and regulations.</li>
                        </ol>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default TermsAndConditions;
